import { useState } from "react";
import { ToastProvider } from "@/os/state/toast";
import { AchievementsProvider } from "@/os/state/achievements";
import { SettingsProvider } from "@/os/state/settings";
import { ThemeProvider } from "@/os/state/theme";
import { ErrorBoundary } from "@/os/ErrorBoundary";
import { BootScreen } from "@/os/boot/BootScreen";
import Desktop from "@/os/desktop/Desktop";

function Shell() {
    const [booted, setBooted] = useState<null | "desktop" | "resume">(null);
    if (booted === null) return <BootScreen onFinish={setBooted} />;
    return <Desktop initialOpen={booted === "resume" ? "resume_pdf" : undefined} />;
}

export default function App() {
    return (
        <ErrorBoundary>
            <ToastProvider>
                <AchievementsProvider>
                    <SettingsProvider>
                        <ThemeProvider>
                            <Shell />
                        </ThemeProvider>
                    </SettingsProvider>
                </AchievementsProvider>
            </ToastProvider>
        </ErrorBoundary>
    );
}
